export const TYPE_OF_BUSINESS = {
    ag: {
        en: 'Agriculture',
        es: 'Agricultura'
    },
    arts: {
        en: 'Arts & Entertainment',
        es: 'Artes y entretenimiento'
    },
    auto: {
        en: 'Automotive',
        es: 'Automotriz'
    },
    bus: {
        en: 'Business Support & Supplies',
        es: 'Apoyo empresarial y suministros'
    },
    comp: {
        en: 'Computers & Electronics',
        es: 'Computadoras y electrónicos'
    },
    con: {
        en: 'Construction & Contractors',
        es: 'Construcción y contratistas'
    },
    ed: {
        en: 'Education',
        es: 'Educación'
    },
    food: {
        en: 'Food & Dining',
        es: 'Comida y restaurantes'
    },
    health: {
        en: 'Health & Medicine',
        es: 'Salud y medicina'
    },
    home: {
        en: 'Home & Garden',
        es: 'Hogar y jardín'
    },
    legal: {
        en: 'Legal & Financial',
        es: 'Legal y financiero'
    },
    manu: {
        en: 'Manufacturing, Wholesale, Distribution',
        es: 'Fabricación, venta al por mayor, distribución'
    },
    merch: {
        en: 'Merchants (Retail)',
        es: 'Comerciantes (minoristas)'
    },
    np: {
        en: 'Nonprofit',
        es: 'Sin fines de lucro'
    },
    pers: {
        en: 'Personal Care & Services',
        es: 'Cuidado personal y servicios'
    },
    real: {
        en: 'Real Estate',
        es: 'Bienes raíces'
    },
    trav: {
        en: 'Travel & Transportation',
        es: 'Viajes y transporte'
    },
    o: {
        en: 'Other',
        es: 'Otro'
    }
} as Record<string, { en: string; es: string }>;
